export enum EModelApiPaths {
    CUSTOM_API_BASE = '/custom-api',
    SYSTEM_API_BASE = '/schema',
    // API Maker's system token endpoint lives under /system-api, not /schema
    SYSTEM_TOKEN_BASE = '/system-api',

    // Auth
    LOGIN = '/website-login',
    REGISTER = '/website-register',
    SEND_OTP = '/send-otp',
    VERIFY_OTP = '/verify-otp',
    FORGOT_PASSWORD = '/forgot-password',
    RESET_PASSWORD = '/reset-password',
    CHANGE_PASSWORD = '/change-password',

    // Profile
    PROFILE = '/profile',
    UPDATE_PROFILE = '/update-profile',

    // Products
    PRODUCTS = '/products',
    PRODUCT_DETAIL = '/product-detail',
    SEARCH = '/search',

    // Categories & Brands
    CATEGORIES = '/categories',
    BRANDS = '/brands',

    // Cart
    CART = '/cart',
    CART_MANAGE = '/cart/manage',
    APPLY_COUPON = '/apply-coupon',

    // Wishlist
    WISHLIST = '/wishlist',
    WISHLIST_TOGGLE = '/wishlist/toggle',

    // Orders
    ORDERS = '/orders',
    CREATE_ORDER = '/create-order',
    ORDER_DETAIL = '/order-detail',
    TRACK_ORDER = '/track-order',
    INVOICE = '/invoice',

    // Payment
    RAZORPAY_CREATE = '/payment/create-order',
    RAZORPAY_VERIFY = '/payment/verify',

    // Addresses
    ADDRESSES = '/addresses',
    ADDRESS_MANAGE = '/address/manage',

    // Reviews
    REVIEWS = '/product-reviews',
    REVIEW_CREATE = '/submit-review',

    // Content
    HOME_DATA = '/home-data',
    BANNERS = '/home-data',
    SITE_CONTENT = '/site-content',
    FAQ = '/faqs',
    STATIC_PAGE = '/static-page',
    CONTACT = '/contact',

    GIFT_CARD = '/gift-card',

    // Pincode
    CHECK_PINCODE = '/check-pincode',
}
